export default __webpack_public_path__ + "static/media/chargeCredit.2cf0a511.mp3";